import React, { useRef, useState, useCallback } from 'react';
import './selfcareIndividual.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import { downloadPdf, openPdf } from '../utils/pdfGenerator';

import PageCover from '../pages/pageCover';
import PageWelcomeSelfcare from '../pages/selfcare/pageWelcomeSelfcare';
import PageResumeSelfcare_1 from '../pages/selfcare/resume/pageResumeSelfcare_1';
import PageResumeSelfcare_2 from '../pages/selfcare/resume/pageResumeSelfcare_2';
import PageResultsByDimensionSelfcare from '../pages/selfcare/pageResultsByDimensionSelfcare';
import PageRiskProfilesSelfcare from '../pages/selfcare/pageRiskProfilesSelfcare';
import PagePredictiveMatricesSelfcare from '../pages/selfcare/pagePredictiveMatricesSelfcare';
import PageRecommendationsSelfcare from '../pages/selfcare/pageRecommendationsSelfcare';
import PageFarewellSelfcare from '../pages/selfcare/pageFarewellSelfcare';
import PageIntroPredictiveSelfcare from '../pages/selfcare/pageIntroPredictiveSelfcare';
import FloatingActionButtons from '../../floatingActionButtons/floatingActionButtons';
import {
    getPredictiveMatricesSelfcarePageCount,
    getRecommendationsSelfcarePageCount,
    getVisibleSelfcareMatrices,
} from '../pages/selfcare/selfcarePredictiveMatrices';

const SelfcareIndividual = ({ totalResults, individualResult, selectedEvaluation, orgLogo }) => {
    const pdfRef = useRef();
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfProgress, setPdfProgress] = useState(null);

    const year = selectedEvaluation?.evl_start_date
        ? new Date(selectedEvaluation.evl_start_date).getFullYear()
        : new Date().getFullYear();

    const employeeName = `${individualResult?.first_name || ''} ${individualResult?.last_name || ''}`.trim();
    const employeeRole = individualResult?.job_title || '';

    const predictiveMatricesStartPage = 10;
    const visiblePredictiveMatrices = getVisibleSelfcareMatrices(individualResult);
    const hasPredictiveContent = visiblePredictiveMatrices.length > 0;
    const predictiveMatricesPageCount = getPredictiveMatricesSelfcarePageCount(individualResult);
    const recommendationsStartPageNumber = predictiveMatricesStartPage + (hasPredictiveContent ? predictiveMatricesPageCount : 0);
    const recommendationsPageCount = getRecommendationsSelfcarePageCount(individualResult);
    const farewellPageNumber = recommendationsStartPageNumber + recommendationsPageCount;

    const pdfFilename = `${selectedEvaluation?.evl_title || 'Autocuidado'} - Reporte Individual.pdf`;
    const onProgress = useCallback((current, total) => setPdfProgress({ current, total }), []);
    const handleDownloadPDF = async () => { setPdfLoading(true); await downloadPdf(pdfRef.current, { filename: pdfFilename, onProgress }); setPdfLoading(false); setPdfProgress(null); };
    const handleOpenPDF = async () => { setPdfLoading(true); await openPdf(pdfRef.current, { filename: pdfFilename, onProgress }); setPdfLoading(false); setPdfProgress(null); };

    return (
        <>
            <div ref={pdfRef} style={{ fontFamily: 'Poppins, sans-serif' }} className="pdf-content">
                <PageCover
                    reportTitle="REPORTE INDIVIDUAL"
                    reportSubtitle="Índice de Autocuidado y Seguridad Humana"
                    orgName={employeeName}
                    orgRole={employeeRole}
                    year={year}
                    general={false}
                    orgLogo={orgLogo}
                />

                <PageWelcomeSelfcare selectedEvaluation={selectedEvaluation} pageNumber={1} individualResult={individualResult} />

                <PageResumeSelfcare_1
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={2}
                />

                <PageResumeSelfcare_2
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={3}
                    totalResults={totalResults}
                />

                <PageResultsByDimensionSelfcare
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={4}
                />

                <PageRiskProfilesSelfcare
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={6}
                />

                <PageIntroPredictiveSelfcare
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={8}
                />

                {hasPredictiveContent && (
                    <PagePredictiveMatricesSelfcare
                        selectedEvaluation={selectedEvaluation}
                        individualResult={individualResult}
                        orgLogo={orgLogo}
                        startPageNumber={predictiveMatricesStartPage}
                    />
                )}

                {recommendationsPageCount > 0 && (
                    <PageRecommendationsSelfcare
                        selectedEvaluation={selectedEvaluation}
                        individualResult={individualResult}
                        orgLogo={orgLogo}
                        startPageNumber={recommendationsStartPageNumber}
                    />
                )}

                <PageFarewellSelfcare
                    selectedEvaluation={selectedEvaluation}
                    individualResult={individualResult}
                    orgLogo={orgLogo}
                    pageNumber={farewellPageNumber}
                />
            </div>

            <FloatingActionButtons
                handleDownloadPDF={handleDownloadPDF}
                handleOpenPDF={handleOpenPDF}
                handleExportExcel={() => console.log('Exportando a Excel...', { totalResults })}
                pdfLoading={pdfLoading}
                pdfProgress={pdfProgress}
            />
        </>
    );
};

export default SelfcareIndividual;
